import React from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { Heading, HeadingLevel } from '@nike/web-a11y-ariakit-react';
import styles from './styles.styl';

export const ResultsSlide = ({
  title,
  copyText,
  alphaSizeCaption,
  alphaSize,
  hybridSizeCaption,
  hybridSize,
  shopLink,
  shopLinkText,
  restartText,
  onRestartButtonClick,
}) => {
  return (
    <div className={styles.content} data-testid="content">
      <HeadingLevel level={3}>
        <Heading className={styles.resultsTitle} data-testid="results-title">
          {title}
        </Heading>
      </HeadingLevel>
      {alphaSize && (
        <>
          <div className={styles.sizeCaption} data-testid="size-caption">
            {alphaSizeCaption}
          </div>
          <div className={styles.resultSize} data-testid="result-size">
            {alphaSize}
          </div>
        </>
      )}
      <div className={styles.sizeCaption} data-testid="size-caption">
        {hybridSizeCaption}
      </div>
      <div className={styles.resultSize} data-testid="result-size">
        {hybridSize}
      </div>
      <p className={styles.resultsCopy} data-testid="results-copy">
        {copyText}
      </p>
      <div className={styles.resultsButton} data-testid="results-button">
        <ButtonStyled
          Component="a"
          href={shopLink}
          size="responsive"
          className="button"
        >
          {shopLinkText}
        </ButtonStyled>
      </div>
      <div className={styles.resultsButton} data-testid="results-button">
        <ButtonStyled
          onClick={onRestartButtonClick}
          appearance="secondary"
          background="light"
          size="responsive"
          className="button"
          data-qa="restart-button"
        >
          {restartText}
        </ButtonStyled>
      </div>
    </div>
  );
};

ResultsSlide.propTypes = {
  alphaSize: PropTypes.string,
  alphaSizeCaption: PropTypes.string,
  copyText: PropTypes.string,
  hybridSize: PropTypes.string,
  hybridSizeCaption: PropTypes.string,
  onRestartButtonClick: PropTypes.func,
  restartText: PropTypes.string,
  shopLink: PropTypes.string,
  shopLinkText: PropTypes.string,
  title: PropTypes.string,
};
